/**
 * How many digits are in an emailed sign-in code.
 *
 * ⚠ THE TRUE VALUE IS NOT IN THIS REPO. GoTrue generates the code, and its
 * length is a Supabase dashboard setting (Authentication → Providers → Email →
 * "Email OTP Length"), per PROJECT. This constant only mirrors it.
 *
 * **8, because that is what the projects already emit.** Test was measured
 * twice on 2026-09-16 and returned an eight-digit, all-numeric `email_otp`
 * both times; fedex-booking-portal's own OTP input is eight for the same
 * reason. Matching the dashboard rather than changing it means this feature
 * ships with no dashboard prerequisite at all — the earlier plan to force both
 * projects to 6 was a deploy-ordering gate for no benefit.
 *
 * If a project's setting is ever moved AWAY from 8, every sign-in there fails:
 * the portal renders eight cells, refuses to submit until eight digits are
 * typed, and the API's `^\d{8}$` schema rejects whatever GoTrue actually sent
 * — surfacing as "Invalid or expired code" for a code that is neither.
 *
 * Both ends of the feature import this one value (the API's zod schema and the
 * portal's cell input), so the two cannot drift apart the way fedex's two
 * "6-digit" comments did. Neither end can READ the dashboard — but the API can
 * see the code GoTrue minted, so `sendLoginCodeIfEligible` compares its length
 * to this constant and logs `login_code_length_mismatch` when they disagree.
 * That log line is the drift detector; the runbook says what to do with it:
 * docs/runbooks/2026-09-16-portal-otp-login-rollout.md.
 */
export const LOGIN_CODE_LENGTH = 8;
